
export const getBookAnchor = (book: BookPageFragment) => {
  return book._id
}
